var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5"},[_c('br'),_c('Banner'),_c('PopularMovie'),_c('LatestMovie'),_c('UpcomingMovie')],1)}
var staticRenderFns = []

export { render, staticRenderFns }